/**
 * preloadPlateNoteEditor — warm the lazy Plate.js editor chunk WITHOUT
 * rendering it, so the heavy bundle is already downloaded and parsed by the
 * time the user clicks into a note to edit. Without this, the first edit pays
 * the full dynamic-import cost (~1s) with a blank editor during the load.
 *
 * Lives in its OWN module (not alongside the PlateNoteEditor component) so the
 * component file stays component-only for react-refresh, while still sharing
 * the exact `./PlateNoteEditorImpl` specifier with that file's `lazy()` import.
 * The bundler/browser dedupe on that specifier, so once this has fired the
 * `lazy()` resolves synchronously from cache and edit mode opens instantly.
 *
 * Idempotent and safe to call eagerly — fire it when a note surface that can
 * enter edit mode mounts (the note record slideout) and on pointer-enter of
 * the editable body.
 */

let preloadPromise: Promise<unknown> | null = null;

export function preloadPlateNoteEditor(): void {
  if (!preloadPromise) {
    preloadPromise = import('./PlateNoteEditorImpl');
  }
}
